import { useState } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

/**
 * Image avec aperçu plein écran au clic — remplace antd Image.
 */
const ImagePreview = (props: {
    src: string;
    alt?: string;
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
    previewable?: boolean;
}) => {
    const [open, setOpen] = useState(false);
    const previewable = props.previewable !== false;

    return (
        <>
            <img
                src={props.src}
                alt={props.alt || ''}
                className={`${previewable ? 'cursor-zoom-in' : ''} ${props.className || ''}`}
                style={{ width: props.width, height: props.height, objectFit: 'cover', ...props.style }}
                onClick={() => previewable && setOpen(true)}
            />
            {open && createPortal(
                <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/70 backdrop-blur-sm" onClick={() => setOpen(false)}>
                    <img src={props.src} alt={props.alt || ''} className="max-w-[90vw] max-h-[90vh] rounded-xl shadow-2xl" />
                    <button className="absolute top-4 right-4 p-2 text-white bg-white/10 hover:bg-white/20 rounded-lg" onClick={() => setOpen(false)}>
                        <X size={20} />
                    </button>
                </div>,
                document.body
            )}
        </>
    );
};

export default ImagePreview;
